// Commented till integration with Gandalf

// Import findIndex from 'lodash/fp/findIndex';
// import first from 'lodash/fp/first';

function Directive() {
  "ngInject";

  // Const role = $injector.get('Authentication').getRole();
  // const Permissions = $injector.get('Permissions');
  // const writePermissions = Permissions.writePermissions;
  // const userPermissions = writePermissions[role];
  return {
    restrict: "A",
    link: () => {
      //   Const transformerName = attrs.hasPermissionItem;
      //   const itemTransformer = transformerName ? $injector.get(transformerName) : null;
      //   const item = itemTransformer ? itemTransformer.item : null;
      //   const itemName = item ? item.name : attrs.hasPermissionName;
      //   if (itemName) {
      //     const notHasPermission = findIndex(p => p === itemName)(userPermissions) === -1;
      //     const childElement = first(element);
      //     const parentElement = childElement.parentNode;
      //     if (notHasPermission) parentElement.removeChild(childElement);
      //   } else if (attrs.hasPermission) {
      //     console.error('Permission name is required');
      //   }
    },
  };
}

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/hasPermission/hasPermission.directive.js